var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 256H384V213.33H0V256ZM0 149.33H384V106.67H0V149.33ZM0 0V42.67H384V0H0Z","fill":"currentColor"}));
}

Menu.defaultProps = {"width":"384","height":"256","viewBox":"0 0 384 256","fill":"none","aria-hidden":"true"};

module.exports = Menu;

Menu.default = Menu;
